module.exports = __webpack_public_path__ + "static/media/right-menu-ranking-event-icon.17245f03.svg";